import type { GalleryImage } from "@/components/feature/GalleryGrid";
import { villaGalleryImages } from "@/pages/villas/gallery-data";
import { frangipaniGalleryImages } from "@/pages/villa-frangipani/gallery-data";
import { bougainvilleaGalleryImages } from "@/pages/villa-bougainvillea/gallery-data";
import { hibiskusGalleryImages } from "@/pages/villa-hibiscus/gallery-data";
import { weddingGalleryImages } from "@/pages/weddings/gallery-data";
import { tourGalleryImages } from "@/pages/tour-info/gallery-data";

export interface GalleryDef {
  key: string;
  labelDe: string;
  labelEn: string;
  images: GalleryImage[];
}

// Zentrales Verzeichnis aller Fotogalerien der Website.
// Der Schlüssel (key) wird auch in der Supabase-Tabelle `gallery_captions`
// verwendet – so findet der Backstage-Editor dieselben Bilder wieder.
export const GALLERY_REGISTRY: GalleryDef[] = [
  {
    key: "villas",
    labelDe: "Villen – Übersicht",
    labelEn: "Villas – overview",
    images: villaGalleryImages,
  },
  {
    key: "villa-frangipani",
    labelDe: "Villa Frangipani",
    labelEn: "Villa Frangipani",
    images: frangipaniGalleryImages,
  },
  {
    key: "villa-bougainvillea",
    labelDe: "Villa Bougainvillea",
    labelEn: "Villa Bougainvillea",
    images: bougainvilleaGalleryImages,
  },
  {
    key: "villa-hibiscus",
    labelDe: "Villa Hibiskus",
    labelEn: "Villa Hibiscus",
    images: hibiskusGalleryImages,
  },
  {
    key: "weddings",
    labelDe: "Hochzeit",
    labelEn: "Weddings",
    images: weddingGalleryImages,
  },
  {
    key: "tour-info",
    labelDe: "Tour-Infos",
    labelEn: "Tour info",
    images: tourGalleryImages,
  },
];

export const getGalleryDef = (key: string): GalleryDef | undefined =>
  GALLERY_REGISTRY.find((g) => g.key === key);

// Deutsche und englische Bild-Beschriftungen werden getrennt abgelegt.
// Deutsch nutzt den normalen Galerie-Schlüssel, Englisch einen eigenen
// Schlüssel mit dem Suffix "__en". So bleiben beide Sprachen sauber
// getrennt, ohne die bestehende Datenstruktur zu verändern.
export const EN_CAPTION_SUFFIX = "__en";

export const galleryKeyForLang = (key: string, lang: "de" | "en"): string =>
  lang === "en" ? `${key}${EN_CAPTION_SUFFIX}` : key;